import React from 'react';
import { Flex, theme } from 'antd';

export type StepDefinition = {
  readonly key: string;
  readonly label: string;
};

type DiagnosticsStepItemProps = {
  step: StepDefinition;
  isCompleted: boolean;
  isPrevCompleted: boolean;
  isFirst: boolean;
  isLast: boolean;
};

export default function DiagnosticsStepItem({ step, isCompleted, isPrevCompleted, isFirst, isLast }: DiagnosticsStepItemProps) {
  const { token } = theme.useToken();
  const dotSize = isCompleted ? 10 : 8;

  return (
    <Flex
      vertical
      align="center"
      gap={8}
      style={{ flex: 1, minWidth: 0 }}
    >
      <Flex align="center" gap={4} style={{ width: '100%', height: 10 }}>
        <div
          data-testid={`step-line-${step.key}`}
          data-completed={String(isPrevCompleted)}
          style={{
            flex: 1,
            height: 2,
            backgroundColor: isPrevCompleted ? token.colorPrimary : token.colorBorderSecondary,
            transition: 'background-color 0.3s',
            visibility: isFirst ? 'hidden' : undefined,
          }}
        />
        <div
          data-testid={`step-dot-${step.key}`}
          data-completed={String(isCompleted)}
          style={{
            width: dotSize,
            height: dotSize,
            borderRadius: '50%',
            backgroundColor: isCompleted ? token.colorPrimary : token.colorBorderSecondary,
            transition: 'all 0.3s',
            flexShrink: 0,
          }}
        />
        <div
          data-testid={`step-line-after-${step.key}`}
          data-completed={String(isCompleted)}
          style={{
            flex: 1,
            height: 2,
            backgroundColor: isCompleted ? token.colorPrimary : token.colorBorderSecondary,
            transition: 'background-color 0.3s',
            visibility: isLast ? 'hidden' : undefined,
          }}
        />
      </Flex>
      <span
        style={{
          fontSize: token.fontSizeSM,
          lineHeight: '20px',
          color: isCompleted ? token.colorText : token.colorTextDescription,
          textAlign: 'center',
        }}
      >
        {step.label}
      </span>
    </Flex>
  );
}
